// eslint-disable-next-line no-unused-vars
export default {
  dateFilterParams: {
    comparator(filterLocalDateAtMidnight, cellValue) {
      const dateAsString = cellValue;
      if (dateAsString == null) return -1;
      const dateParts = dateAsString.split('-');
      const cellDate = new Date(
        Number(dateParts[0]),
        Number(dateParts[1]) - 1,
        Number(dateParts[2]),
      );
      if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        return 0;
      }
      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      }
      return 1;
    },
    browserDatePicker: true,
    buttons: ['reset'],
  },
  numberFilterParams: {
    buttons: ['reset'],
  },
  textFilterParams: {
    buttons: ['reset'],
    debounceMs: 200,
  },
};
